<auth-template>
	<div class="content-container">
		<button
			*ngIf="(requestSuccess$ | async) === false"
			mat-button
			class="ficon-arrow-left btn-none back-btn"
			role="button"
			[attr.aria-label]="'common_back' | translate"
			(click)="navigateBack()">
		</button>
		<div class="content-space">
			<form
				*ngIf="(requestSuccess$ | async) === false"
				(ngSubmit)="submit(form)"
				[formGroup]="form">
				<h4 translate="forgot-password_title" class="header"></h4>
				<p translate="forgot-password-reset_paragraph_text" class="description"></p>

				<div class="form-section">
					<div>
						<mat-form-field appearance="outline">
							<mat-label translate="forgot-password_label"></mat-label>
							<input matInput
								formControlName="email"
								type="email"
								class="fullstory-ignore"
								[attr.aria-label]="'email' | translate"/>
							<mat-error *ngIf="form.controls.email.hasError('required')" translate="login-form_validation-email-required"></mat-error>
							<mat-error *ngIf="form.controls.email.hasError('email')" translate="login-form_validation-email-invalid"></mat-error>
						</mat-form-field>
					</div>
				</div>

				<div class="form-section action-section">
					<button
						type="submit"
						class="primary-btn submit-btn"
						[attr.aria-label]="'forgot-password-button_send' | translate"
						[disabled]="disableRequestPasswordButton() || (disableButton$ | async)">
						<i class="ficon-spinner ficon-spin" *ngIf="loading$ | async"></i>
						<span translate="forgot-password-button_send"></span>
					</button>
					<div class="form-message remaining-lock-message" *ngIf="(resetLockDuration$ | async) as lockDuration">
						<ng-container *ngIf="lockDuration > 0">
							{{ getResendDurationMessage(lockDuration) }}
						</ng-container>
					</div>
					<div class="form-message unknown-error" *ngIf="(requestError$ | async)"
						translate="unknown-error-description">
					</div>
				</div>
			</form>

			<div class="forgot-password-success" *ngIf="requestSuccess$ | async">
				<h4 translate="forgot-password-request-sent_title" class="header"></h4>
				<div class="description">
					{{'forgot-password-request-sent_email_sent' | translate}} {{'forgot-password-request-sent_check_inbox' | translate}}
				</div>

				<div class="button-container action-section">
					<button
						type="button"
						class="primary-btn close-btn"
						[attr.aria-label]="'forgot-password_go-to-login' | translate"
						(click)="navigateBack()">
						<i class="ficon-spinner ficon-spin" *ngIf="loading$ | async"></i>
						<span translate="forgot-password-request-sent_close_btn"></span>
					</button>
				</div>
			</div>
		</div>
	</div>
</auth-template>
